import React from "react";
import { useNavigate } from "react-router-dom";

const VendorCookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-4 py-10 sm:px-6 lg:px-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="mb-8 flex items-center text-[#2A668D] hover:underline"
      >
        <span className="material-symbols-outlined mr-1">arrow_back</span>
        Back
      </button>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-[#2A668D] mb-6 text-center">
          Cookie Policy
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6 text-justify">
          Our platform uses cookies to improve your browsing experience. This policy explains what cookies we use and why.
        </p>

        <div className="space-y-5 text-gray-700 text-justify">
          <p>
            <strong>1. What Are Cookies?</strong> Cookies are small data files stored on your browser when you visit a website.
          </p>
          <p>
            <strong>2. Why We Use Cookies:</strong> To remember your login session, store preferences, and gather analytics.
          </p>
          <p>
            <strong>3. Cookie Types:</strong> Session cookies, preference cookies, and analytics cookies.
          </p>
          <p>
            <strong>4. Managing Cookies:</strong> You can disable cookies in your browser, but some features may not work correctly.
          </p>
          <p>
            <strong>5. Consent:</strong> By using our site, you consent to our use of cookies in accordance with this policy.
          </p>
        </div>

        <div className="text-gray-600 text-sm text-center mt-10">
          Last updated: {new Date().toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default VendorCookiePolicy;
